import api from 'utils/api';

const resetPassword = (values) => () => {
  const url = '/auth/password/reset';

  return api.patch(url, { ...values, source: 'reiloans' });
};

export default resetPassword;
